"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitializedField = void 0;
var react_1 = require("react");
var utils_1 = require("utils");
var useInitializedField = function (forwardedRef, _a) {
    var initiallyFocused = _a.initiallyFocused;
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var inputRef = (0, utils_1.useSharedRef)(null, [forwardedRef]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (initialized)
            return;
        if (initiallyFocused) {
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setInitialized(true);
    }, [initiallyFocused, initialized, setInitialized]);
    return inputRef;
};
exports.useInitializedField = useInitializedField;
